<template>
  <v-container fluid>
    <v-row v-if="files.length">
      <v-col cols="12" v-for="(file, index) in files" :key="index">
        <card-file-novo
            :file="file"
            :uri="uri"
            :habilitar-exclusao="habilitarExclusao"
            @CardFile_remove="arquivoRemovido">
        </card-file-novo>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CardFileNovo from './CardFileNovo';

export default {
  name: 'ListFilesNovo',
  components: { CardFileNovo },
  props: {
    uri: '',
    habilitarExclusao: {
      type: Boolean,
      default: false,
    },
    tipoDocumento: {
      type: Number,
      default: null,
    },
    habilitarTipoArquivo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      files: [],
    };
  },
  watch: {
    possuiArquivos(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('ListFiles_ITENS_ALTERADOS', newValue);
      }
    },
  },
  computed: {
    possuiArquivos() {
      return !!(this.files && this.files.length);
    },
  },
  methods: {
    carregarArquivos(callback) {
      let request;
      if (this.tipoDocumento === 0 || this.habilitarTipoArquivo) {
        request = this.$http.get(`${this.uri}/tipo-documento/${this.tipoDocumento}/list`);
      } else {
        request = this.$http.get(`${this.uri}/list`);
      }
      request.then((response) => {
        this.files = response.body;
        this.$emit('ListFiles__arquivos', this.files);
        if (callback) {
          callback();
        }
      });
    },
    refresh(callback) {
      this.files = [];
      setTimeout(() => this.carregarArquivos(callback), 1E2);
    },
    arquivoRemovido() {
      this.$emit('ListFiles__arquivoRemovido');
      this.refresh();
    },
  },
  mounted() {
    this.carregarArquivos();
  },
};
</script>

<style scoped>

</style>
